<template>
  <v-data-table :page.sync="pageNo" :headers="headers" :items="configurationArray">
    <template v-slot:item.status="{ item }">
      <span v-if="item.status === 'ACTIVE'" class="green--text text--accent-4">
        {{ item.status }}
      </span>
      <span v-else-if="item.status === 'INACTIVE'" class="red--text text--accent-4">
        {{ item.status }}
      </span>
      <span v-else>
        {{ item.status }}
      </span>
    </template>
    <template v-slot:item.action="{ item }">
      <v-btn @click="openViewDetails(item)" color="accent" small outlined>View Details</v-btn>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: 'BomConfigurationTable',
  props: {
    configurationList: {
      type: Array,
      default: () => []
    },
    C1_APPROVED: {
      type: Boolean,
      default: false
    },
    C2_APPROVED: {
      type: Boolean,
      default: false
    },
    C3_APPROVED: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      headers: [
        { text: 'Configuration Date', value: 'createdAt', align: 'center' },
        { text: 'Model', value: 'franchiseeModel.title', align: 'center' },
        { text: 'status', value: 'status', align: 'center' },
        { text: 'view details', value: 'action', align: 'center' }
      ],
      configurationArray: this.configurationList.length > 0 ? this.configurationList : [],
      pageNo: 1
    }
  },
  watch: {
    configurationList: {
      handler: function (newVal) {
        this.pageNo = 1
        this.configurationArray = newVal
      },
      deep: true
    },
    C1_APPROVED: function (newVal) {
      if (newVal) {
        this.addConfiguredByHeader()
      }
    },
    C2_APPROVED: function (newVal) {
      if (newVal) {
        this.addConfiguredByHeader()
      }
    },
    C3_APPROVED: function (newVal) {
      if (newVal) {
        this.addConfiguredByHeader()
      }
    }
  },
  created () {
    if (this.C1_APPROVED || this.C2_APPROVED || this.C3_APPROVED) {
      this.addConfiguredByHeader()
    }
  },
  methods: {
    openViewDetails: async function (item) {
      let obj = {}
      obj.wowKitSetModalMapID = item.id
      obj.model = item.franchiseeModel.id
      obj.status = item.status
      await this.$emit('openViewDetailsDialog', obj)
    },
    addConfiguredByHeader: function () {
      let configuredBy = { text: 'Configured By', value: 'createdBy' }
      if (this.headers.indexOf(configuredBy) === -1) {
        this.headers.splice(1, 0, configuredBy)
      }
    }
  }
}
</script>
